module.exports = __webpack_public_path__ + "img/bg3.540a082b.jpg";